export interface IRequestConfig<T> {
  method?: MethodsTypes;
  headers?: IHeaders;
  url?: string;
  baseUrl?: string;
  timeout?: number;
  data?: T | undefined | any;
  distributionCenter?: string;
  params?: IParams | any;
  key?: string;
  paramsSerializer?: (params: any) => string;
}

export interface IHeaders {
  [key: string]: string;
}

export interface IParams {
  [key: string]: string | number | undefined;
}

/**
 * HTTP Methods to request API
 * @GET The GET method means retrieve whatever information (in the form of an entity) is identified by the Request-URI
 * @POST The POST method means retrieve whatever information (in the form of an entity) is identified by the Request-URI
 * @PUT The PUT method means retrieve whatever information (in the form of an entity) is identified by the Request-URI
 * @PATCH The PATCH method means retrieve whatever information (in the form of an entity) is identified by the Request-URI
 * @DELETE The DELETE method means retrieve whatever information (in the form of an entity) is identified by the Request-URI
 */
export enum MethodsTypes {
  get = "get",
  post = "post",
  put = "put",
  patch = "patch",
  delete = "delete",
}
